import { render, staticRenderFns } from "./DocumentFilter.vue?vue&type=template&id=39dca90a&scoped=true&"
import script from "./DocumentFilter.vue?vue&type=script&lang=js&"
export * from "./DocumentFilter.vue?vue&type=script&lang=js&"
import style0 from "./DocumentFilter.vue?vue&type=style&index=0&id=39dca90a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dca90a",
  null
  
)

export default component.exports